// @flow
import React, { PureComponent } from 'react';
import type { Pratique, PratiqueAgenda } from 'types/Club';

type Props = {
  practices: Pratique[]
};

class ClubPractices extends PureComponent<Props> {
  isMobileHidden = (agenda: PratiqueAgenda[], indexAgenda: number) => {
    if (indexAgenda === agenda.length - 1) {
      return 'mobile-hidden';
    } else if (indexAgenda === 0) {
      return 'no-border';
    } else {
      return 'no-border mobile-hidden';
    }
  };

  renderPractices: () => Array<any> = () => {
    const pratiques = this.props.practices.sort((a, b) => {
      const x = a.name.toLowerCase();
      const y = b.name.toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });

    return pratiques.map<any>((practice, index) => {
      if (practice.agenda && practice.agenda.length > 0) {
        return practice.agenda.map((agenda, indexAgenda) => {
          const lieu = agenda.Adresse && (agenda.Adresse.complement || agenda.Adresse.voie);

          return (
            <tr key={'agenda_' + indexAgenda} className={'pratique_' + indexAgenda}>
              <td className={this.isMobileHidden(practice.agenda, indexAgenda)} data-title="Type de pratique">
                {indexAgenda === 0 && practice.name === 'Rugby à 5' ? 'Rugby à 5 Loisir - Bien être' : practice.name}
              </td>
              <td className={this.isMobileHidden(practice.agenda, indexAgenda)} data-title="Responsable">
                {indexAgenda === 0 &&
                  practice.contact &&
                  practice.contact[0] &&
                  practice.contact[0].prenom + ' ' + practice.contact[0].nom}
              </td>
              <td data-title="jour">{agenda.jourNom.charAt(0).toUpperCase() + agenda.jourNom.slice(1)}</td>
              <td data-title="horaire">
                {(agenda.heureDebut ? agenda.heureDebut.substr(0, 5) : '') +
                  (agenda.heureFin ? '-' + agenda.heureFin.substr(0, 5) : '')}
              </td>
              <td data-title="lieu">
                {lieu && (
                  <span>
                    <a
                      href={`https://www.google.com/maps/dir/?api=1&destination=${
                        agenda.Adresse.complement ? agenda.Adresse.complement : ''
                      }+${agenda.Adresse.voie ? agenda.Adresse.voie : ''}+${
                        agenda.Adresse.localite ? agenda.Adresse.localite : ''
                      }`}
                      title={"Visualiser l'adresse du club sur Google Maps (nouvel onglet)"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon icon-place is-inline" />
                      {lieu}
                    </a>
                  </span>
                )}
              </td>
            </tr>
          );
        });
      }
      const lieu =
        practice.agenda &&
        practice.agenda[0] &&
        practice.agenda[0].Adresse &&
        (practice.agenda[0].Adresse.complement || practice.agenda[0].Adresse.voie);
      return (
        <tr key={index}>
          <td className="" data-title="Type de pratique">
            {practice.name === 'Rugby à 5' ? 'Rugby à 5 Loisir - Bien être' : practice.name}
          </td>
          <td className="" data-title="Responsable">
            {practice.contact && practice.contact[0] && practice.contact[0].prenom + ' ' + practice.contact[0].nom}
          </td>
          <td data-title="jour">
            {practice.agenda &&
              practice.agenda[0] &&
              practice.agenda[0].jourNom.charAt(0).toUpperCase() + practice.agenda[0].jourNom.slice(1)}
          </td>
          <td data-title="horaire">
            {practice.agenda &&
              practice.agenda[0] &&
              practice.agenda[0].heureDebut &&
              practice.agenda[0].heureDebut.substr(0, 5) +
                '-' +
                (practice.agenda[0].heureFin ? '-' + practice.agenda[0].heureFin.substr(0, 5) : '')}
          </td>
          <td data-title="lieu">
            {lieu && (
              <span>
                <a
                  href={`https://www.google.com/maps/dir/?api=1&destination=${
                    practice.agenda[0].Adresse.complement ? practice.agenda[0].Adresse.complement + '+' : ''
                  }${practice.agenda[0].Adresse.voie ? practice.agenda[0].Adresse.voie : ''}+${
                    practice.agenda[0].Adresse.localite ? practice.agenda[0].Adresse.localite : ''
                  }`}
                  title={"Visualiser l'adresse du club sur Google Maps (nouvel onglet)"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="icon icon-place is-inline" />
                  {lieu}
                </a>
              </span>
            )}
          </td>
        </tr>
      );
    });
  };

  render() {
    if (this.props.practices.length === 0) {
      return null;
    }

    return (
      <React.Fragment>
        <h3 className="mb-3">Pratiques du rugby proposées</h3>
        <div className="practices-table box box--smoke mb-2 mb-6 mb-md-7">
          <table className="table tabled-bordered">
            <thead>
              <tr>
                <th>Type de pratique</th>
                <th>Responsable</th>
                <th>Jour</th>
                <th>Horaire</th>
                <th>Lieu</th>
              </tr>
            </thead>
            <tbody>{this.renderPractices()}</tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }
}

export default ClubPractices;
